module.exports = __webpack_public_path__ + "img/empty_shop.bdc2c522.png";